const ASC = "asc";
const DESC = "desc";

const exports = {
    ASC,
    DESC,

    SORT_DIR_MAP: {
        [DESC]: "-",
        [ASC]: ""
    },
};

export default exports;